import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'contributions-sheet',
  templateUrl: './contributions-sheet.component.html',
  styleUrls: ['./contributions-sheet.component.scss']
})
export class ContributionsSheetComponent { }
